import React from "react";
import Skill from "./Skill";
import { skills } from "./utils/data";

const Skills = () => {
  return (
    <div
      id="skills"
      className="font-mono w-full mt-[50vh] flex flex-col items-center flex-wrap"
    >
      <h1 className="text-white font-bold text-[35px] mb-[25px]">Skills</h1>
      <div className="border-2 border-slate-50 h-auto w-full p-10 rounded-3xl shadow-[rgba(0,_0,_0,_0.4)_0px_30px_90px]">
        {Object.keys(skills).map((skill, index) => (
          <Skill key={index} skills={skills[skill]} title={skill} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
